import React from 'react';
import { useAuth } from './App';

const DharmaSastramPage = () => {
  const { language } = useAuth();

  const pdfs = [
    {
      id: 1,
      title_en: 'Dharma Sastra Surukkam',
      title_ta: 'தர்ம சாஸ்திர சுருக்கம்',
      description_en: 'A concise summary of basic Dharma Sastras every Sri Vaishnava should know.',
      description_ta: 'ஒவ்வொரு ஸ்ரீ வைஷ்ணவனும் தெரிந்து கொள்ள வேண்டிய அடிப்படை தர்ம சாஸ்திரங்களின் சுருக்கம்.',
      filename: 'dharma-sastra-surukkam.pdf',
      icon: '📖'
    },
    {
      id: 2,
      title_en: 'Asoucha Kandam',
      title_ta: 'ஆசௌச காண்டம்',
      description_en: 'Rules and regulations regarding purity and impurity (Theetu) during births and deaths.',
      description_ta: 'பிறப்பு மற்றும் இறப்பின் போது ஏற்படும் தீட்டு மற்றும் தூய்மை குறித்த விதிமுறைகள்.',
      filename: 'asoucha-kandam.pdf',
      icon: '🕊️'
    },
    {
      id: 3,
      title_en: 'Dharma Sastram Volume 1',
      title_ta: 'தர்ம சாஸ்திரம் தொகுதி 1',
      description_en: 'Detailed volume on daily rituals and practices.',
      description_ta: 'அன்றாட சடங்குகள் மற்றும் நடைமுறைகள் குறித்த விரிவான தொகுதி.',
      filename: 'DS1.pdf',
      icon: '📚'
    },
    {
      id: 4,
      title_en: 'Shraddha Eligible Things',
      title_ta: 'ச்ராத்தத்திற்கு உகந்த பொருட்கள்',
      description_en: 'List of items permitted and prohibited during Shradhdham rituals.',
      description_ta: 'ச்ராத்த சடங்குகளின் போது அனுமதிக்கப்பட்ட மற்றும் தவிர்க்க வேண்டிய பொருட்களின் பட்டியல்.',
      filename: 'shraaddha-eligible-things.pdf',
      icon: '🌾'
    },
    {
      id: 5,
      title_en: 'Shradham Importants',
      title_ta: 'ச்ராத்தத்தின் முக்கிய குறிப்புகள்',
      description_en: 'Key rules and procedures for performing annual ceremonies.',
      description_ta: 'வருடாந்திர சடங்குகளைச் செய்வதற்கான முக்கிய விதிகள் மற்றும் நடைமுறைகள்.',
      filename: 'shradham-importants.pdf',
      icon: '🕉️'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50 to-white py-12 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-orange-800 mb-6 drop-shadow-sm">
            {language === 'en' ? 'Dharma Sastram' : 'தர்ம சாஸ்திரம்'}
          </h1>
          <p className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed text-justify md:text-center">
            {language === 'en' 
              ? 'Dharma Sastram is the foundational guide for leading a righteous life. Download our curated collection of ancient wisdom formatted for modern readers. These texts explain the proper procedures, rules, and significance of various Vedic rituals and daily practices.' 
              : 'தர்ம சாஸ்திரம் என்பது தர்ம வழியில் வாழ்வதற்கான அடிப்படை வழிகாட்டியாகும். அன்றாட நடைமுறைகள், சடங்குகள் மற்றும் தீட்டு விதிமுறைகளை விளக்கும் நமது பண்டைய நூல்களின் தொகுப்பை இங்கே பதிவிறக்கம் செய்துகொள்ளலாம்.'}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {pdfs.map((pdf) => (
            <div key={pdf.id} className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border-t-4 border-orange-600 group flex flex-col">
              <div className="p-8 flex-grow">
                <div className="text-5xl mb-6 text-center transform group-hover:scale-110 transition-transform duration-300">
                  {pdf.icon}
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">
                  {language === 'en' ? pdf.title_en : pdf.title_ta}
                </h3>
                <p className="text-gray-600 text-center leading-relaxed">
                  {language === 'en' ? pdf.description_en : pdf.description_ta}
                </p>
              </div>
              <div className="p-6 bg-orange-50 mt-auto border-t border-orange-100">
                <a 
                  href={`/dharma-sastram/${pdf.filename}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center w-full bg-orange-600 text-white px-6 py-3 rounded-xl font-bold hover:bg-orange-700 transition-colors shadow-md"
                >
                  <span className="mr-2">📥</span>
                  {language === 'en' ? 'Download PDF' : 'பதிவிறக்கம் செய்க'}
                </a>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-16 bg-orange-100 border-l-4 border-orange-600 p-6 md:p-8 rounded-lg shadow-sm">
          <h3 className="text-xl font-bold text-orange-800 mb-3 flex items-center">
            <span className="text-2xl mr-2">📌</span> 
            {language === 'en' ? 'Note regarding downloads' : 'முக்கிய குறிப்பு'}
          </h3>
          <p className="text-gray-800 leading-relaxed text-justify">
            {language === 'en' 
              ? 'These documents have been compiled from authentic sources by Ahobilam.com. They are provided for personal reference and educational purposes to help our community follow traditional practices accurately.' 
              : 'இந்த ஆவணங்கள் அனைத்தும் நமது ஸ்ரீ வைஷ்ணவ சம்பிரதாய நூல்களிலிருந்து அஹோபிலம்.காம் மூலம் தொகுக்கப்பட்டுள்ளன. நமது பாரம்பரிய பழக்கவழக்கங்களை மக்கள் சரியாகப் பின்பற்றுவதற்காக இவை இலவசமாக வழங்கப்படுகின்றன.'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default DharmaSastramPage;
